/* eslint-disable no-unused-vars */
export const usePos = true;
export const interactivePos = false;
export const messagePos = <>Récupérer le ticket commerçant du TPE. <br/> Si un seul ticket : noter "buvette" au dos. <br/> Si plusieurs tickets : les regrouper et noter "buvette" sur la pochette. <br/> Mettre le tout dans la banette comptabilité du club.<br/> <br/> </>